function pushToDataLayer(eventName, data, product_data, currency, value) {
  dataLayer.push({ ecommerce: null });

  // console.log({eventName, data});

  if (!product_data) {
    product_data = {
      "product_type": null,
      "delivery_frequency": null
    }
  }

  dataLayer.push({
      event: eventName,
      ecommerce: {
          ...(currency != null && { currency }),
          ...(value != null && { value }),
          product_type: product_data.product_type,
          delivery_frequency: product_data.delivery_frequency,
          items: data
      }
  });
}

function trackingFormatPrice(price, divisor = 100) {
  return `${(price / divisor).toFixed(2)}`
}

function trackingGetProductDiscount(data) {
  if (!data.compare_at_price) return 0
  return data.price - data.compare_at_price;
}

// Get cookie function
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

async function updateKlaviyoConsent() {
  const marketingConsent = window.Shopify.customerPrivacy.currentVisitorConsent().marketing;
  const klaIdCookie = getCookie('__kla_id');
  const previousConsent = localStorage.getItem('marketingConsent');
  klaviyo.push(['track', 'Klaviyo Consent Update Initiated',
    {
      "marketingConsent": marketingConsent,
      "previousConsent": previousConsent,
      "klaIdCookie": klaIdCookie
    }
  ]);

  if ((marketingConsent === 'yes' && (previousConsent === 'no' || previousConsent === '' || previousConsent === null)) && klaIdCookie) {
    try {
      await klaviyo.identify({});
      klaviyo.push(['track', 'Marketing Consent Granted',
        {
          "marketingConsent": marketingConsent,
          "previousConsent": previousConsent,
          "klaIdCookie": klaIdCookie
        }
      ]);
      klaviyo.push(['identify', {
        'ad_personalization': 'granted',
        'ad_user_data': 'granted',
      }]);
      localStorage.setItem('marketingConsent', marketingConsent);
    } catch (error) {
      console.error('An error occurred:', error);
    }
  } else if (marketingConsent === 'no' && previousConsent === 'yes' && klaIdCookie) {
    const decodedKlaId = atob(klaIdCookie);
    const klaIdObj = JSON.parse(decodedKlaId);
    const kla_exchange_id = klaIdObj.$exchange_id;

    if (kla_exchange_id) {
      try {
        const response = await fetch('https://a.klaviyo.com/client/profiles/?company_id='+window.klaviyoCompanyID, {
          method: 'POST',
          headers: {
            'accept': 'application/json',
            'content-type': 'application/json',
            'revision': '2024-02-15'
          },
          body: JSON.stringify({
            "data": {
              "type": "profile",
              "attributes": {
                "_kx": kla_exchange_id,
                "properties": {
                  "ad_personalization": "denied",
                  "ad_user_data": "denied"
                }
              }
            }
          })
        });
        const data = await response.json();
        localStorage.setItem('marketingConsent', marketingConsent);
      } catch (error) {
        console.error('Error:', error);
      }
    }
  }
}

window.addEventListener('load', updateKlaviyoConsent);